<template>
    <div>
        <mt-cell :title="model.caption" :required="param.required" v-if="!param.readonly" :titlewidth="titlewidth" :value-align="textalign" >
            <mt-button-list v-model="currentValue" :options="options" :multiple="multiple" :display.sync="display"></mt-button-list>
        </mt-cell>
        <mt-cell :title="model.caption" :readonly="param.readonly" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign" >
            <div class="em-select-value mt-color-grey-lv3">
                <template>{{display}}</template>
            </div>
        </mt-cell>
        <!-- <mt-field :label="model.caption" v-if="param.readonly" readonly v-model="display" :titlewidth="titlewidth" :value-align="textalign"></mt-field> -->
    </div>
</template>
<script>
export default {

    name: 'emButtonlist',

    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: { default: '' },
        displayValue: { default: '' },
        options: {
            type: Array,
            default: function() {
                return [];
            }
        },
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        }
    },

    data() {
        return {
            currentValue: this.value,
            display: this.displayValue
        }
    },

    computed: {
        multiple() {
            let xtype = this.model.xtype;
            return xtype !== 'buttonlist';
        },
        param() {
            return this.model.initParam;
        }
    },

    watch: {
        value(val) {
            this.currentValue = val;
        },
        currentValue(val) {
            this.$emit('input', val);
        },
        displayValue(val) {
            this.display = val;
        },
        display(val) {
            this.$emit('update:displayValue', val);
        }
    },

    mounted() {
        this.$el.click();
    }
}
</script>
<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// emButtonlist.vue?343cc5a3